import Pomodoro from './layout/Pomodoro'

function App() {
    return (
        <div className="flex items-center justify-center w-screen h-screen">
            <main>
                <Pomodoro />
            </main>
        </div>
    )
}

export default App
